// import { color } from '../../../styles/GlobalStyles';
// import {
//   Box,
//   Flexed,
//   Pill,
//   UserImageCircle
// } from '../../../styles/GlobalComponents';

// import { H3, H4, P3 } from '../../../styles/FontStyles';
// import { User } from '../../../types/loginTypes';

// export const TopSponsorPerformer = ({
//   user,
//   index
// }: {
//   user: User;
//   index: number;
// }) => {
//   return (
//     <Box border mb='8' mbSM='8' p='10px 20px' pSM='10px 15px'>
//       <Flexed gap='5px' center>
//         <Flexed center gap='10px' gapSM='10px'>
//           <Flexed width='20px' widthSM='20px' end>
//             <H3
//               right
//               style={{ textAlign: 'right' }}
//               color={color.colors.primary900}>
//               {index + 1}
//             </H3>
//           </Flexed>
//           <UserImageCircle
//             image={user?.profileImageUrl}
//             name={user?.name}
//             surname={user?.surname}
//             size='40px'
//             fontSize='16px'
//             margin={'0 8px 0 0'}
//           />
//         </Flexed>
//       </Flexed>
//     </Box>
//   );
// };

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import {
  Icon,
  IconBonusDashboard,
  IconDashboardTimer,
  IconFastStartUser,
  IconLapTop,
  IconMyTeamDashboard,
  IconShoppingCart,
  IconThunderSuccess,
  IconThunderError,
  IconTimer,
  IconUser,
  IconThunderDisabled
} from '../../../styles/Icons';
import { color } from '../../../styles/GlobalStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { Separator } from '../../MyTeamBackoffice/MyTeamBackofficeStyled';
import { PackageRankMyProgressModel } from '../../Ranking/Ranking.types';
import {
  dateDifferenceInDays,
  dateDifferenceInDaysFromToday,
  formatUSD,
  formatUSDNoDecimals,
  formatVP
} from '../../../helpers/helperFunctions';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  CaptionText,
  H1,
  H4,
  H5,
  P1,
  P2,
  P3
} from '../../../styles/FontStyles';
import { TextWithTooltip } from '../../../components/common/TextWithTooltip';
import { Link } from 'react-router-dom';
import {
  CASHBACK_BONUS,
  ENTRY_PACKAGE,
  MY_TEAM,
  SETTINGS_VIRTUAL_OFFICE
} from '../../../routes/routes';
import moment from 'moment';
import { Counter } from './Counter';
import { claimCashback } from '../../CashbackBonus/CashbackBonus.actions';
import { AsyncThunkAction } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';

import { Mobile, Desktop } from '../../../App';

const TextWrapper = styled.div`
  flex: 1;
`;

const StepTitle = styled.h2<{ faded?: boolean }>`
  font-size: 30px;
  font-weight: 700;
  color: #a3835b;
  opacity: ${({ faded }) => (faded ? 0.6 : 1)};

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const StepDesc = styled.p<{ faded?: boolean }>`
  margin-top: 5px;
  color: #4b5563;
  opacity: ${({ faded }) => (faded ? 0.6 : 1)};
  font-size: 18px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const UsdcText = styled.p<{ faded?: boolean }>`
  color: ${({ theme }) => theme.colors.primary900};
  opacity: ${({ faded }) => (faded ? 0.6 : 1)};
  font-size: 14px;
  margin-left: 5px;

  @media (max-width: 768px) {
    font-size: 10px;
    margin-left: 2px;
  }
`;

const Timer = styled.div`
  background: #ecd9db;
  color: #ef4444;
  height: 40px;
  padding: 0 12px;
  border-radius: 12px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(239, 68, 68, 0.5);
  margin-left: 100px;

  @media (max-width: 768px) {
    margin-left: 0px;
    margin-top: 30px;
  }
`;

export const TopSponsorPerformer = ({
  ranking
}: {
  ranking: PackageRankMyProgressModel[];
}) => {
  const [users, setUsers] = useState<any>();
  const [hub, setHub] = useState<any>();

  const dispatch = useAppDispatch();
  const { dashboardInfo, teamInfo } = useAppSelector(
    (state) => state.dashboard
  );

  const { info, statusPerPackage } = useAppSelector((state) => state.cashback);

  const getNextRank = (ranking: PackageRankMyProgressModel[]) => {
    const nextRank = ranking.slice(0, -3)?.find((r) => r.isNextRank);
    if (!nextRank) {
      return ranking.slice(0, -3)[0];
    }
    return nextRank;
  };

  const licence = dateDifferenceInDaysFromToday(
    dashboardInfo?.user?.currentVirtualOfficeLicence?.dateEnd
  );

  const disabledIcons = () => {
    if (getNextRank(ranking)?.name === 'Qualified Partner') {
      if (
        !getNextRank(ranking)?.hasPaidHub ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInLeftLeg ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInRightLeg
      ) {
        return true;
      } else return false;
    } else {
      if (
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInLeftLeg ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInRightLeg
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  const disabledText = () => {
    if (getNextRank(ranking)?.name === 'Qualified Partner') {
      if (
        !getNextRank(ranking)?.hasPaidHub ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInLeftLeg ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInRightLeg
      ) {
        return '#aeadad';
      } else return '#6A7282';
    } else {
      if (
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInLeftLeg ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInRightLeg
      ) {
        return '#aeadad';
      } else {
        return '#6A7282';
      }
    }
  };

  const disabledBonus = () => {
    if (getNextRank(ranking)?.name === 'Qualified Partner') {
      if (
        !getNextRank(ranking)?.hasPaidHub ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInLeftLeg ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInRightLeg
      ) {
        return '#c1ae96';
      } else return color.colors.primary900;
    } else {
      if (
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInLeftLeg ||
        !getNextRank(ranking)?.hasPartnerWithPaidPackageInRightLeg
      ) {
        return '#c1ae96';
      } else {
        return color.colors.primary900;
      }
    }
  };

  let days = dateDifferenceInDays(info?.dateFrom, info?.limitDate);

  const date = new Date(dashboardInfo?.user?.fastStartBonus?.limitDate ?? '');
  const timestamp = date.getTime();

  const claimedFastStartIcon = () => {
    if (hub?.hasEnoughDirectUsers) {
      return <IconThunderSuccess />;
    } else if (info?.isLimitDatePassed) {
      return <IconThunderDisabled />;
    } else {
      return <IconThunderError />;
    }
  };

  const claimedFastStart = () => {
    if (hub?.hasEnoughDirectUsers) {
      return false;
    } else if (info?.isLimitDatePassed) {
      return true;
    } else {
      return false;
    }
  };

  const renderFastStartUsers = () => {
    return statusPerPackage.filter((hub) => {
      const match = hub.hubNames.match(/\(([\d.]+)\s*USDT\)/);
      const value = match ? parseFloat(match[1]) : null;

      return value === info?.maxClaimablePackagePrice;
    });
  };

  const renderFastStartClaimedUsers = () => {
    const hub = renderFastStartUsers();
    setHub(hub[0]);
    setUsers(hub[0]?.directUsers);
  };

  const renderFastStartIcons = () => {
    return Array.from({ length: 5 }).map((_, i) => {
      const user = users?.[i];

      return (
        <Icon
          ml={i === 0 ? '10' : '0'}
          color={user?.id ? '#1BB915' : undefined}
          key={i}>
          <IconFastStartUser />
        </Icon>
      );
    });
  };

  useEffect(() => {
    renderFastStartClaimedUsers();
  }, [statusPerPackage]);

  return (
    <>
      <Link to={ENTRY_PACKAGE}>
        <Flexed gap='1' alignStart>
          <Icon mt='5'>
            <IconShoppingCart
              success={
                getNextRank(ranking)?.name !== 'Qualified Partner'
                  ? true
                  : getNextRank(ranking)?.hasPaidHub
                  ? true
                  : false
              }
            />
          </Icon>

          <TextWrapper>
            <StepTitle>1. Buy Your Package</StepTitle>
            <StepDesc>
              Mine Bitcoin, leverage advanced AI,
              <br /> spend freely, and access elite education
            </StepDesc>
          </TextWrapper>
        </Flexed>
      </Link>
      <Link to={SETTINGS_VIRTUAL_OFFICE}>
        <Flexed gap='1' mt='40' alignStart>
          <Icon mt='5'>
            <IconLapTop success={licence > 30 ? true : false} />
          </Icon>

          <TextWrapper>
            <StepTitle>2. Buy Back Office Subscription</StepTitle>
            <StepDesc>Activate full platform benefits</StepDesc>
          </TextWrapper>
        </Flexed>
      </Link>

      <Link to={MY_TEAM}>
        <Flexed gap='1' mt='40' alignStart>
          <Icon mt='5'>
            <IconUser
              success={
                getNextRank(ranking)?.name !== 'Qualified Partner'
                  ? true
                  : getNextRank(ranking)?.hasPartnerWithPaidPackageInLeftLeg &&
                    getNextRank(ranking)?.hasPartnerWithPaidPackageInRightLeg
                  ? true
                  : false
              }
            />
          </Icon>{' '}
          <TextWrapper>
            <StepTitle>3. Achieve Qualified Partner status</StepTitle>
            <StepDesc>Sell 1 package on Left and 1 on Right</StepDesc>
          </TextWrapper>
        </Flexed>
      </Link>

      <Flexed gap='1' mt='40' alignStart>
        <Link to={CASHBACK_BONUS}>
          <Flexed gap='1'>
            <Icon>{claimedFastStartIcon()}</Icon>

            <Flexed between gap='5'>
              <TextWrapper>
                <Flexed>
                  <StepTitle faded={claimedFastStart()}>
                    4. Get Fast Start Bonus
                  </StepTitle>
                </Flexed>

                <Flexed center>
                  <StepDesc
                    faded={claimedFastStart()}
                    style={{ whiteSpace: 'nowrap' }}>
                    Enroll 5 people in {days} days
                  </StepDesc>
                  {renderFastStartIcons()}
                </Flexed>
              </TextWrapper>
            </Flexed>
          </Flexed>
        </Link>
        <Desktop>
          {info?.isLimitDatePassed ? (
            <>
              {info?.isCashbackBonusCalculated ? (
                <Button
                  style={{ height: 40, width: 150, marginLeft: 100 }}
                  disabled={!info?.canClaimCashbackBonus}>
                  Claimed
                </Button>
              ) : (
                info?.canClaimCashbackBonus && (
                  <Button
                    onClick={() => dispatch(claimCashback())}
                    style={{ height: 40, width: 150, marginLeft: 100 }}
                    disabled={!info?.canClaimCashbackBonus}>
                    Claim Reward
                  </Button>
                )
              )}
            </>
          ) : info?.canClaimCashbackBonus ? (
            <Button
              onClick={() => dispatch(claimCashback())}
              style={{ height: 40, width: 150, marginLeft: 100 }}
              disabled={!info?.canClaimCashbackBonus}>
              Claim Reward
            </Button>
          ) : (
            <Timer>
              <Icon mr='5'>
                <IconDashboardTimer />
              </Icon>

              <Counter timestamp={timestamp} />
            </Timer>
          )}
        </Desktop>
      </Flexed>
      <Mobile>
        {info?.isLimitDatePassed ? (
          <>
            {info?.isCashbackBonusCalculated ? (
              <Button
                style={{ height: 40, width: '100%', marginTop: 30 }}
                disabled={!info?.canClaimCashbackBonus}>
                Claimed
              </Button>
            ) : (
              info?.canClaimCashbackBonus && (
                <Flexed column center>
                  <Button
                    onClick={() => dispatch(claimCashback())}
                    style={{ height: 40, width: '100%', marginTop: 30 }}
                    disabled={!info?.canClaimCashbackBonus}>
                    Claim Reward
                  </Button>
                </Flexed>
              )
            )}
          </>
        ) : info?.canClaimCashbackBonus ? (
          <Flexed column center>
            <Button
              onClick={() => dispatch(claimCashback())}
              style={{ height: 40, width: '100%', marginTop: 30 }}
              disabled={!info?.canClaimCashbackBonus}>
              Claim Reward
            </Button>
          </Flexed>
        ) : (
          <Timer>
            <Icon mr='5'>
              <IconDashboardTimer />
            </Icon>

            <Counter timestamp={timestamp} />
          </Timer>
        )}
      </Mobile>

      <Separator />

      <Link
        to={disabledIcons() ? '#' : MY_TEAM}
        onClick={(e) => {
          if (disabledIcons()) {
            e.preventDefault();
          }
        }}
        style={{
          pointerEvents: disabledIcons() ? 'none' : 'auto',
          cursor: disabledIcons() ? 'not-allowed' : 'pointer'
        }}>
        <Flexed gap='1' mt='40'>
          <Icon color={disabledIcons() ? '#aeadad' : color.colors.primary900}>
            <IconMyTeamDashboard />
          </Icon>

          <TextWrapper>
            <StepTitle style={{ color: '#6A7282' }} faded={disabledIcons()}>
              5. Build your Team
            </StepTitle>
            <StepDesc style={{ color: '#6A7282' }} faded={disabledIcons()}>
              Expand your network strategically and start your own business.
            </StepDesc>
          </TextWrapper>
        </Flexed>
      </Link>

      <Flexed gap='1' mt='40'>
        <Link
          to={disabledIcons() ? '#' : MY_TEAM}
          onClick={(e) => {
            if (disabledIcons()) {
              e.preventDefault();
            }
          }}
          style={{
            // pointerEvents: disabledIcons() ? 'none' : 'auto',

            cursor: disabledIcons() ? 'not-allowed' : 'pointer'
          }}>
          <Flexed column alignStart>
            <Icon
              mt='5'
              color={disabledIcons() ? '#aeadad' : color.colors.primary900}>
              <IconBonusDashboard />
            </Icon>
          </Flexed>
        </Link>
        <Flexed column>
          <Link
            to={disabledIcons() ? '#' : MY_TEAM}
            onClick={(e) => {
              if (disabledIcons()) {
                e.preventDefault();
              }
            }}
            style={{
              // pointerEvents: disabledIcons() ? 'none' : 'auto',

              cursor: disabledIcons() ? 'not-allowed' : 'pointer'
            }}>
            <StepTitle style={{ color: '#6A7282' }} faded={disabledIcons()}>
              6. Earn Multiple Bonuses
            </StepTitle>
            <StepDesc style={{ color: '#6A7282' }} faded={disabledIcons()}>
              Unlock your full earning potential. Claim your USDT/USDC rewards{' '}
              <br />
              as your network grows.
            </StepDesc>
          </Link>
          <Desktop>
            <Flexed center>
              <Flexed column>
                <P2 caps bold mr='40' mt='20' color={disabledText()}>
                  POWER LEG BV
                </P2>
                <P2 bold color={disabledBonus()}>
                  {formatVP(teamInfo?.powerLegBv)}{' '}
                </P2>
              </Flexed>

              <Flexed column>
                <Flexed>
                  <P2 caps bold mt='20' color={disabledText()}>
                    UNREALIZED TEAM BONUS{' '}
                  </P2>
                  <TextWithTooltip
                    margin='22px 0 0 0'
                    tooltip='Generate matching volume in your weaker leg to get this bonus.'
                  />
                </Flexed>
                <Flexed alignEnd>
                  <P2 bold mb='1' color={disabledBonus()}>
                    {formatUSDNoDecimals(teamInfo?.unrealizedTeamBonus)}{' '}
                  </P2>
                  <UsdcText color={disabledBonus()} style={{ marginBottom: 4 }}>
                    USDT/USDC
                  </UsdcText>
                </Flexed>
              </Flexed>
            </Flexed>
          </Desktop>
          <Mobile>
            <Flexed center>
              <Flexed column>
                <CaptionText caps bold mr='40' mt='20' color={disabledText()}>
                  POWER LEG BV
                </CaptionText>
                <P3 bold color={disabledBonus()}>
                  {formatVP(teamInfo?.powerLegBv)}{' '}
                </P3>
              </Flexed>

              <Flexed column>
                <Flexed>
                  <CaptionText caps bold mt='20' color={disabledText()}>
                    UNREALIZED TEAM BONUS{' '}
                  </CaptionText>
                  <TextWithTooltip
                    margin='19px 0 0 0'
                    tooltip='Generate matching volume in your weaker leg to get this bonus.'
                  />
                </Flexed>
                <Flexed alignEnd>
                  <P3 bold color={disabledBonus()}>
                    {formatUSDNoDecimals(teamInfo?.unrealizedTeamBonus)}{' '}
                  </P3>
                  <UsdcText color={disabledBonus()} style={{ marginBottom: 3 }}>
                    USDT/USDC
                  </UsdcText>
                </Flexed>
              </Flexed>
            </Flexed>
          </Mobile>
        </Flexed>
      </Flexed>
      {/* </Link> */}
    </>
  );
};
